import createDataStoreSlice from '../../../modules/utilities/store/slices/dataStore'
import { makeActionCreator } from '../../../modules/utilities/store'
import ZoneDeviceDataStoreSagaHandlers from '../../sagas/data/ZoneDeviceDataStore'
import zoneDeviceDataStoreReducer, {
  ZONE_DEVICE_DATA_STORE_SLICE_NAME,
  zoneDeviceDataStoreTypes
} from '../../reducers/data/zoneDeviceDataStoreReducer'

const ZoneDeviceDataStoreSlice = createDataStoreSlice(
  ZONE_DEVICE_DATA_STORE_SLICE_NAME,
  undefined,
  ZoneDeviceDataStoreSagaHandlers
)

ZoneDeviceDataStoreSlice.reducer = zoneDeviceDataStoreReducer
ZoneDeviceDataStoreSlice.actions = {
  ...ZoneDeviceDataStoreSlice.actions,
  fetchResult: makeActionCreator(zoneDeviceDataStoreTypes.FETCH_RESULT, 'result', 'callback', 'zoneId')
}

export default ZoneDeviceDataStoreSlice
